<template>
  <div class="page-wrapper storybook-cnc-badge-label">
    <StorybookTemplate title="CncBadgeLabel" pathComponent="/shared/elements/global/v1/CncBadgeLabel.vue" :propList="propList" :form.sync="form">
      <CncBadgeLabel v-bind="form">{{ form.name }}</CncBadgeLabel>
    </StorybookTemplate>
  </div>
</template>

<script>
export default {
  components: {
    StorybookTemplate: () => import('../../../../components/StorybookTemplate.vue')
  },
  data () {
    return {
      propList: [
        { name: 'label', type: 'input', param: 'label' },
        {
          name: 'size',
          type: 'select',
          param: 'size',
          default: 'large',
          option: [
            { label: 'extra-small', name: 'Extra Small' },
            { label: 'small', name: 'Small' },
            { label: 'medium', name: 'Medium' },
            { label: 'large', name: 'Large' }
          ]
        },
        {
          name: 'type',
          type: 'select',
          param: 'type',
          default: 'primary',
          option: [
            { label: 'primary', name: 'Primary' },
            { label: 'secondary', name: 'Secondary' },
            { label: 'neutral', name: 'Neutral' },
            { label: 'positive', name: 'positive' },
            { label: 'critical', name: 'Critical' },
            { label: 'in-progress', name: 'In Progress' },
            { label: 'warning', name: 'Warning' },
            { label: 'informing', name: 'Informing' },
            { label: 'concerning', name: 'Concerning' }
          ]
        },
        {
          name: 'style',
          type: 'select',
          param: 'styleBadge',
          default: 'bold',
          option: [
            { label: 'bold', name: 'Bold' },
            { label: 'subtle', name: 'Subtle' },
            { label: 'minimal', name: 'Minimal' },
            { label: 'text', name: 'Text' },
            { label: 'bold-on-color', name: 'Bold on color' },
            { label: 'outlined-on-color', name: 'Outlined on color' },
            { label: 'text-on-color', name: 'Text on color' }
          ]
        },
        {
          name: 'leftIcon',
          type: 'object',
          param: 'leftIcon',
          objectKey: [
            { key: 'name', type: 'input', value: 'insert_checkin' }
          ]
        },
        { name: 'isNumber', type: 'boolean', param: 'isNumber' },
        { name: 'currency', type: 'input', param: 'currency' },
        { name: 'isAbbreviated', type: 'boolean', param: 'isAbbreviated' },
        { name: 'outline', type: 'boolean', param: 'outline' },
        { name: 'isTruncate', type: 'boolean', param: 'isTruncate' }
      ],

      form: {
        label: 'Label',
        size: 'large',
        type: 'primary',
        styleBadge: 'bold',
        leftIcon: { type: 'icon', name: 'ico_check_through_circle' },
        isTruncate: false
      }
    }
  }
}
</script>
